import anime from 'animejs';

export function destroyAnimeInstance(instance: AnimeInstance) {
    instance.pause();
    anime.running.splice(anime.running.indexOf(instance), 1);
}
